<div
  id="caterer"
  class="page-layout simple left-sidebar inner-sidebar inner-scroll"
  [ngStyle]="{
    width: '100%',
    'overflow-x': isSmallScreen ? 'scroll' : 'none',
  }"
>
  <!-- HEADER -->

  <div class="gt2-theme">
    <div
      class="header accent py-24 pl-24 pr-8 mat-elevation-z1 caterer-header"
      fusePerfectScrollbar
    >
      <div class="flex-row-start-center">
        <button
          class="mr-0 mr-sm-16 white-fg caterer-back-btn caterer-back-btn-desktop"
          mat-icon-button
          (click)="onPageBack(location, router)"
        >
          <mat-icon class="icon-mat">arrow_back</mat-icon>
        </button>
        <mat-icon class="header-page-icon">account_balance</mat-icon>
        <div class="flex-column-start-start">
          <div
            class="caterer-title"
            *fuseIfOnDom
            [@animate]="{
              value: '*',
              params: { delay: '100ms', x: '-25px' },
            }"
          >
            <div *ngIf="caterer" class="">
              <span class="text-truncate">
                {{ caterer.name | uppercase }}
              </span>
            </div>
          </div>

          <div *ngIf="caterer" class="flex-row-start-start">
            <div *ngIf="caterer.account_mode_label">
              {{ caterer.account_mode_label }}
            </div>
            <div *ngIf="caterer.account_mode === 'TRIAL'">
              &nbsp; - {{ "CATERER.TRIAL" | translate }}:
              {{ caterer.trial_ended_at_label }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex-row-start-center">
        <button
          class="mr-8 white-fg caterer-back-btn caterer-back-btn-mobile"
          mat-icon-button
          (click)="onPageBack(location, router)"
        >
          <mat-icon class="icon-mat">arrow_back</mat-icon>
        </button>
        <button
          mat-button
          matTooltip="{{ 'GENERIC.OPEN_NEW_TAB' | translate }}"
          (click)="onOpenInNewTab()"
          class="mat-icon-button"
          *hideOn="'mobile'"
        >
          <mat-icon class="s-30 icon-mat">{{ getIcon("NEW_TAB") }}</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- / HEADER -->

  <!-- SUB HEADER -->
  <div
    *ngIf="caterer"
    fusePerfectScrollbar
    style="min-height: 50px"
    class="primary mat-elevation-z12 py-8 gt2-sub-header content-subheader flex-row-space-between-center"
  ></div>
  <!-- / SUB HEADER -->

  <!--HISTORY SIDEBAR-->
  <!-- <fuse-sidebar name="productHistoryPanel" position="right" class="section-history-panel">
      <app-section-history-panel panelName="productHistoryPanel" section="products" sectionUUID="{{productID}}"></app-section-history-panel>
  </fuse-sidebar> -->

  <div class="content">
    <!--HISTORY SIDEBAR BUTTON-->
    <!-- <div *ngxPermissionsOnly="['GOD']">
          <button mat-icon-button class="warn mat-elevation-z2 historic-button" *fuseIfOnDom [@animate]="{value:'*', params:{delay:'300ms',scale:'.2'}}"
              (click)="toggleHistoricSidebarOpen('productHistoryPanel')">
              <mat-icon>history</mat-icon>
          </button>
      </div> -->

    <!-- CENTER -->
    <div class="center p-24 pb-56 pr-sm-72">
      <!-- CONTENT -->
      <div class="caterer-content flex-column">
        <!-- STATS -->
        <div
          *ngIf="caterer && caterer.stats"
          class="fxFlexNoAuto flex-column fxFlex-100"
        >
          <div
            class="widget-group flex-column-center-start fxLayoutWrap fxFlex-100p"
            *fuseIfOnDom
          >
            <fuse-widget
              [@animate]="{ value: '*', params: { y: '100%' } }"
              class="widget flex-column fxFlex-100"
            >
              <div
                class="fuse-widget-front mat-white-bg mat-elevation-z2 bg-total"
              >
                <div class="pl-16 pr-8 py-16 h-52 flex-row-center-center">
                  <div class="h3">{{ "CATERER.TOTAL_USER" | translate }}</div>
                </div>

                <div class="pt-8 pb-32 flex-column-center-center">
                  <div class="red-fg font-size-36 line-height-36 text-center">
                    {{ caterer.users_count }}
                  </div>
                </div>
              </div>
            </fuse-widget>
          </div>
        </div>
        <!-- STATS END -->

        <!-- INFORMATION -->
        <div class="profile-box info-box general mt-12 flex-column">
          <header class="accent">
            <div class="title">{{ "GENERIC.INFORMATION" | translate }}</div>
          </header>
          <div class="content">
            <div
              *ngIf="caterer"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.NAME" | translate }}</div>
                <div class="info text-truncate">{{ caterer.name }}</div>
                <div *ngIf="!caterer.name" class="info empty-value"></div>
              </div>

              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="catererForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.NAME" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="name"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="caterer.name"
                        required
                      />
                      <mat-error *ngIf="catererForm.controls['name'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">
                  {{ "CATERER.RESPONSIBLE_USER" | translate }}
                </div>
                <div *ngIf="caterer.owner_user" class="info text-truncate">
                  {{ caterer.owner_user.name }}
                </div>
                <div *ngIf="!caterer.owner_user" class="info empty-value"></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <app-gt2-select
                    [service]="userService"
                    [placeHolder]="'CATERER.SELECT_EMPLOYEE' | translate"
                    [label]="''"
                    [selectedModel]="caterer.owner_user"
                    (changeEvent)="onOwnerUserChange($event)"
                    [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
                    [nullableUseNone]="false"
                    class="item-full-width fxFlex-100p"
                  ></app-gt2-select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ADDRESS -->
        <div
          *ngIf="caterer"
          class="profile-box info-box general mt-12 flex-column"
        >
          <header class="accent">
            <div class="title">{{ "GENERIC.ADDRESS" | translate }}</div>
          </header>
          <div class="">
            <app-address
              #addressComponent
              [groupModel]="caterer.address"
              [isVisible]="true"
              [allowPoBox]="true"
              [editMode]="false"
              [useAutosave]="false"
              class=""
            ></app-address>
          </div>
        </div>

        <!-- CONTACT -->
        <div
          *ngIf="caterer"
          class="profile-box info-box general mt-12 flex-column"
        >
          <header class="accent">
            <div class="title">{{ "GENERIC.CONTACT" | translate }}</div>
          </header>
          <div class="">
            <app-contact
              #contactComponent
              [groupModel]="caterer.contact"
              [editMode]="false"
              [useAutosave]="false"
              class=""
            >
            </app-contact>
          </div>
        </div>

        <!-- CATERER LIST -->
        <div
          *ngIf="caterer"
          class="profile-box info-box general mt-12 flex-column"
        >
          <header class="accent">
            <div class="title">{{ "CATERER.ORG_LIST" | translate }}</div>
          </header>
          <div class="">
            <div
              *ngIf="modulesService.hasOrgIdentity()"
              class="flex-row-end-center org-list-toolbar"
            >
              <button
                *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES"
                mat-raised-button
                color="accent"
                (click)="onCreateIdentity()"
              >
                <mat-icon class="mr-4">add</mat-icon>
                {{ "CATERER.IDENTITY_ADD" | translate }}
              </button>
            </div>
            <mat-table
              #table
              class="jobs-table"
              [dataSource]="orgList.dataSource"
            >
              <!-- Nom Column -->
              <ng-container cdkColumnDef="name">
                <mat-header-cell class="fxFlex-288" *cdkHeaderCellDef>
                  {{ "GENERIC.NAME" | translate }}
                </mat-header-cell>
                <mat-cell
                  class="no-text-cursor fxFlex-288"
                  *cdkCellDef="let org"
                >
                  <p class="text-truncate">
                    {{ org.name }}
                  </p>
                </mat-cell>
              </ng-container>

              <!-- Type Column -->
              <ng-container cdkColumnDef="type">
                <mat-header-cell class="fxFlex" *cdkHeaderCellDef>
                  {{ "CATERER.ORG_TYPE" | translate }}
                </mat-header-cell>
                <mat-cell class="no-text-cursor fxFlex" *cdkCellDef="let org">
                  <p class="text-truncate">
                    {{
                      (org.rowType === "identity"
                        ? "CATERER.ORG_TYPE_IDENTITY"
                        : "CATERER.ORG_TYPE_INTERNAL"
                      ) | translate
                    }}
                  </p>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actionsColumn">
                <mat-header-cell
                  *cdkHeaderCellDef
                  class="fxFlex-100"
                  style="padding: 0; margin: 0; margin-right: 10px"
                >
                </mat-header-cell>
                <mat-cell
                  *cdkCellDef="let org"
                  class="fxFlex-100"
                  style="padding: 0; margin: 0; margin-right: 10px"
                >
                  <button
                    mat-icon-button
                    color="primary"
                    type="button"
                    focusable="false"
                    class="ml-8"
                    (click)="onEditRow(org)"
                  >
                    <span>
                      <mat-icon class="s-20 icon-mat-dark">edit</mat-icon>
                    </span>
                  </button>
                  <ng-container *ngxPermissionsOnly="P.CONFIG_ORG_IDENTITIES">
                    <button
                      *ngIf="org.rowType === 'identity'"
                      mat-icon-button
                      color="warn"
                      type="button"
                      focusable="false"
                      (click)="$event.stopPropagation(); onDeleteIdentity(org)"
                    >
                      <span>
                        <mat-icon class="s-20 icon-mat-dark">delete</mat-icon>
                      </span>
                    </button>
                  </ng-container>
                </mat-cell>
              </ng-container>

              <mat-header-row
                *cdkHeaderRowDef="displayedOrganizationColumns"
              ></mat-header-row>
              <mat-row
                *cdkRowDef="let org; columns: displayedOrganizationColumns"
                class=""
                (click)="onEditRow(org)"
                matRipple
              >
              </mat-row>
            </mat-table>
          </div>
        </div>
        <!-- GT-APP LOGOS -->
        <div
          *ngIf="caterer"
          class="profile-box info-box general mt-12 flex-column"
        >
          <header class="accent">
            <div class="title">{{ "CATERER.GT_APP_LOGOS" | translate }}</div>
          </header>
          <div class="content">
            <div class="logo-upload-row">
              <!-- GT-APP Logo White -->
              <div class="logo-upload-block">
                <div class="title">{{ "CATERER.LOGO_WHITE" | translate }}</div>
                <div class="logo-preview-container logo-preview-dark">
                  <img
                    *ngIf="caterer.gt_app_logo_white"
                    [src]="caterer.gt_app_logo_white + '?t=' + assetCacheBuster"
                    alt="GT-APP Logo White"
                    class="logo-preview-img"
                  />
                  <div
                    *ngIf="!caterer.gt_app_logo_white"
                    class="logo-placeholder"
                  >
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <div class="logo-requirement">
                  {{ "CATERER.LOGO_PNG_ONLY" | translate }}
                </div>
                <input
                  type="file"
                  accept="image/png"
                  #gtAppWhiteInput
                  style="display: none"
                  (change)="onAssetFileSelected($event, 'gt_app_white')"
                />
                <button
                  *ngxPermissionsOnly="P.CONFIG_ORGANIZATION"
                  mat-raised-button
                  color="accent"
                  class="mt-8"
                  [disabled]="gtAppWhiteUploading"
                  (click)="onSelectAssetFile('gt_app_white')"
                >
                  <mat-icon class="mr-4">cloud_upload</mat-icon>
                  {{ "CATERER.UPLOAD_ASSET" | translate }}
                </button>
                <mat-progress-bar
                  *ngIf="gtAppWhiteUploading"
                  mode="indeterminate"
                  class="mt-8"
                ></mat-progress-bar>
              </div>

              <!-- GT-APP Logo Color -->
              <div class="logo-upload-block">
                <div class="title">{{ "CATERER.LOGO_COLOR" | translate }}</div>
                <div class="logo-preview-container logo-preview-light">
                  <img
                    *ngIf="caterer.gt_app_logo_color"
                    [src]="caterer.gt_app_logo_color + '?t=' + assetCacheBuster"
                    alt="GT-APP Logo Color"
                    class="logo-preview-img"
                  />
                  <div
                    *ngIf="!caterer.gt_app_logo_color"
                    class="logo-placeholder"
                  >
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <div class="logo-requirement">
                  {{ "CATERER.LOGO_PNG_ONLY" | translate }}
                </div>
                <input
                  type="file"
                  accept="image/png"
                  #gtAppColorInput
                  style="display: none"
                  (change)="onAssetFileSelected($event, 'gt_app_color')"
                />
                <button
                  *ngxPermissionsOnly="P.CONFIG_ORGANIZATION"
                  mat-raised-button
                  color="accent"
                  class="mt-8"
                  [disabled]="gtAppColorUploading"
                  (click)="onSelectAssetFile('gt_app_color')"
                >
                  <mat-icon class="mr-4">cloud_upload</mat-icon>
                  {{ "CATERER.UPLOAD_ASSET" | translate }}
                </button>
                <mat-progress-bar
                  *ngIf="gtAppColorUploading"
                  mode="indeterminate"
                  class="mt-8"
                ></mat-progress-bar>
              </div>
            </div>
          </div>
        </div>

        <!-- DEFAULT PRODUCT IMAGE -->
        <div
          *ngIf="caterer"
          class="profile-box info-box general mt-12 flex-column"
        >
          <header class="accent">
            <div class="title">
              {{ "CATERER.DEFAULT_PRODUCT_IMAGE" | translate }}
            </div>
          </header>
          <div class="content">
            <div class="logo-upload-row">
              <div class="logo-upload-block">
                <div class="logo-preview-container logo-preview-product">
                  <img
                    *ngIf="caterer.product_default_image"
                    [src]="
                      caterer.product_default_image + '?t=' + assetCacheBuster
                    "
                    alt="Default Product Image"
                    class="logo-preview-img"
                  />
                  <div
                    *ngIf="!caterer.product_default_image"
                    class="logo-placeholder"
                  >
                    <mat-icon>image</mat-icon>
                  </div>
                </div>
                <div class="logo-requirement">
                  {{ "CATERER.PRODUCT_DEFAULT_PNG_ONLY" | translate }}
                </div>
                <input
                  type="file"
                  accept="image/png"
                  #productDefaultInput
                  style="display: none"
                  (change)="onAssetFileSelected($event, 'product_default')"
                />
                <button
                  *ngxPermissionsOnly="P.CONFIG_ORGANIZATION"
                  mat-raised-button
                  color="accent"
                  class="mt-8"
                  [disabled]="productDefaultUploading"
                  (click)="onSelectAssetFile('product_default')"
                >
                  <mat-icon class="mr-4">cloud_upload</mat-icon>
                  {{ "CATERER.UPLOAD_ASSET" | translate }}
                </button>
                <mat-progress-bar
                  *ngIf="productDefaultUploading"
                  mode="indeterminate"
                  class="mt-8"
                ></mat-progress-bar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- / CONTENT -->
    </div>
    <!-- / CENTER -->
  </div>
</div>

<div *ngIf="caterer" class="flex-row-end-start">
  <div *ngxPermissionsOnly="P.CONFIG_ORGANIZATION">
    <div class="fixed-button">
      <button
        mat-fab
        appEditShortcut
        class="gt2-edit-button"
        id="edit-caterer-button"
        [disabled]="loading"
        [matTooltip]="
          editMode
            ? ('GENERIC.SAVE' | translate) + ' (F2)'
            : ('GENERIC.EDIT' | translate) + ' (F2)'
        "
        (click)="onEdit($event)"
        *fuseIfOnDom
        [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
      >
        <mat-icon *ngIf="!editMode" class="icon-mat-black">{{
          getIcon("EDIT_FAB")
        }}</mat-icon>
        <mat-icon *ngIf="editMode" class="icon-mat-black">{{
          getIcon("UNDO")
        }}</mat-icon>
      </button>
    </div>
  </div>
</div>
